export const HOME_URL = '/'
export const REQUEST_URL = '/request'
export const TEST_URL = '/test'
